import { render } from "./g-standalone-layout.vue?vue&type=template&id=c9864fdc&ts=true"
import script from "./g-standalone-layout.vue?vue&type=script&lang=tsx"
export * from "./g-standalone-layout.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__